import React, { useEffect } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';
import { useTheme } from '../../../theming/useTheme';
import { BaseUnit } from '../../../theming/baseUnitDefinition';
import { MEDIA_BREAKPOINTS } from '../../../mediaQueries.const';

interface TaboolaComponentThemeProps {
  baseUnit: BaseUnit
}

type TaboolaComponentProps = TaboolaComponentThemeProps;

const createStyle = (baseUnit: BaseUnit) => {
  return StyleSheet.create({
    style: {
      paddingTop: `${baseUnit * 2}px`,
      paddingLeft: `${baseUnit}px`,
      paddingRight: `${baseUnit}px`,
      [MEDIA_BREAKPOINTS.LARGE]: {
        paddingLeft: `${baseUnit + 80}px`,
      },
    },
  });
};

const useTaboola = () => {
  useEffect(() => {
    // @ts-ignore TS2339
    // eslint-disable-next-line no-underscore-dangle
    window._taboola = window._taboola || [];
    // @ts-ignore TS2339
    // eslint-disable-next-line no-underscore-dangle
    window._taboola.push({
      mode: 'thumbnails-c',
      container: 'taboola-below-article-feed',
      placement: 'Below Article Feed',
      target_type: 'mix',
    });
    // @ts-ignore TS2339
    // eslint-disable-next-line no-underscore-dangle
    window._taboola.push({ flush: true });
  }, []);
};

export const TaboolaComponent: React.FunctionComponent<TaboolaComponentProps> = React.memo(({ baseUnit }) => {
  useTaboola();
  const style = createStyle(baseUnit);
  return (
    <ErrorBoundary>
      <div className={css(style.style)}>
        <div id="taboola-below-article-feed" />
      </div>
    </ErrorBoundary>
  );
});


const mapThemeToProps = (theme: TaboolaComponentProps) => ({
  baseUnit: theme.baseUnit,
});

export const Taboola: React.FunctionComponent<{}> = props => {
  const themeContext = useTheme(mapThemeToProps);
  return <ErrorBoundary><TaboolaComponent {...themeContext} {...props} /></ErrorBoundary>;
};
